
    //Ønsker:
    //Unngå cacha sidetittel og kunne sette sidetittel fra websida.    
    //Rowlock: sp_ws_p2_datatask_columns() sier ikke noe om pr rad for editable.
    //Kunne slå av pager. 
    //Kunne sette pager lik antall rader som man kunne før.
    //Kunne sette valgt antall rader som default for sida.
    //Sette pager til mer enn 500 rader.
    //Datetime konverteres til utc når kommer til databasen, har midlertidig løsning med hardkodet norsk tidssone med SWITCHOFFSET +01:00 i databasen.
    //"CellClickHandler" virker ikke på datofelt, så får ikke fortalt javascript at brukeren har markert linja.
    //Nummersortering for alle nummerdatatyper i databasen
    //Slippe å måtte ha timer i loadGridData()  og i "gridReady = true"
    //Sortert som griden i gridfunc.getAllRows()
    //På onClose-eventen så returneres 'null' når null når er et tall.
    //Når taber til kryss-felt så mistes editeringen. 
    //Når taber til kryss felt så endres krysset som om man klikker på det. Gjorde en workaround i component.
    //Event i optionfunct når ferdig å laste data? Så slipper å måtte ha timer i loadGridData()  og i "gridReady = true"
    //Optionfunc-event når ferdig å laste data i grid

    //Spørsmål til Robin:
    //Hvordan oppdatere griden (ikke data) når endrer felt som "title" og "hidden" i gridfunc.getGrid())
    //Hva er vm.grid.gridfunc.getResponse()?
    //Hvordan få lagt inn id til lagring i lookupsearch uten å ha id først i navnet man velger?
    //Fikk ikkje verdi i @parm_row i loopupsearch-prosedyra
    //Event for når du har valgt i lookupsearch så kan endre tilhørende lookupfelt da?
    //Hva utløser LookupCellEditor-eventen?
    //Fjerner direktivet navnedelen fra lookupsearch-servicen når man er på et id-feil men ikke et navnefelt?
    //Hvordan få selectrow på øverste rad automatisk fra start? Måtte foreløpig bruke setfocus() og timer på 2 sekund!
    //Hvordan finne ut hvilken rad man er på i "OnCellClose", vet kun hvor man har vært?
    //Vise time og timestamp i grid riktig med timevelger uten sekund og tusendeler
    //Kunne fjerne sekund og tusendeler på datetime-felt i grid

    //Spørsmål til TT-møte:
    //Sender inn dagens dato i datofelt, kunne ta vekk i direktiv?
    //Vente halvt minutt for hver endring av javascript, mindre senere med ny versjon av angular?
        

    //Gjøre:

    //Tittelknapp og spaceknapper lager feilmelding når trykker på dem, fiks det.
    //Når det blir bare en rad på "scan søk" eller "db søk"så vis detail-side automatisk. Skifter fra grid til dette for enkelte eventid når blir bare en rad.
    //"Ny rad"-lagring: Lagre hele raden i en gang når ny rad, så slipper problemet med "not null-kolonner" og lagring av default-verdier. Defaultverdi basert på en verdi i params til menyen (trengs til sida for ny menyrad)
    //Varsel om at endring av primarykey ikke er mulig (også når er to av dem), f.eks "button" i "Alle knapper"
    //Ny rad med insoft-tellere også. (autoincrement er max + 1 fordi må vise i grid før lagrer)
    
    //Showid-felt: kryss viser dropdown id
    //Lag sider for dropdownene
    //Hent dropdown_id fra primarykey til lookuptabellen, dropdown_name fra nytt navne-felt "lookup" som er lagt inn for, ellers 2. feltet og sub1 og sub2(i dropdownfelt istedet for mange kryss - felt),
    //Nytt felt lookup istedet for dropdown_table
    //lookupcolumnfilter1 i lookupsearch, bruk gridpage_keyno som referanse.
    //Søke i joina navn.
    //lookupchoice og lookupchoicelang med felt choice (id og navn_no og navn_gb) og type or sertering, kan bruke lookupseach i stedet for kryss for å spare antall felt.
    //Ctrl + E for å editere lookupdata (dynamics triks)
    //Rekkfølge på lookup-felt fungerer ikke alltid.

    //Forbedre special_gridpage_generate_page sin dropdown-felt-generering. Lag varsel i gridpageinit når har glemt å regenerere etter å ha lagt til felt i databsetabellen så sida tryner.
    //Lag prosedyrekall fra special_gridpage_proc så forenkler datatask_columns, bruker eget felt for leserettighet fra special_gridpage så slipper det i dataprosedyra. Denne hindrer lagring av de som ike skal det. Får valg for kun leserettigheter da også i special_gridproc()
    //Greater og lesser som parameter i meny i stedet for som default på sidene, greater = greater or equial, lesser = leser or equial. Ta vekk felt som Beskrivelse på Sider, = > < feltstørrelse på Kolonner osv.
    //"in()" og "not in ()" i url som parameter, brukes i "resten"-meny-menyen
    //Dersom searchfilter krysset av så søker på dei, dersom ikke finnes så søkes på alle feltene!
    //Meny webpage-felt åpner opp save og proc sikkerhet, nytt meny lese-webpage-felt åpner opp proc sikkerhet men ikke save-sikkerhet eller bruker meny-tilgang som readonly
    //Sjekk url-sikkerhet så ikke kan gjøre ting i url som man ikke har lov til
    //Bare ha pålogga businessco i griden når ikke er businessco som primærnøkkel
        
    //Ikke kunne slå på knappeprosedyre på web, ta vekk kryss for dette. Slås på/av i selve knappe-prosedyra. For sikkerhet.
    //Ctrl + m = lage ny meny om ikke finnes, velger menymappe på menylaginga, tittel settes inn samme på meny, params genereres med lookupsercher.
    //Oppater-knapp henter alle felt in fra databsen på nytt, "Fjern ubrukte felt"-knapp, fjerner alle ubrukte felt.
   
    //Funksjon som sjekker om grid er klar hvert 10-dels sekund når åpner sida
    //Ny rad ikke bare øverst
    //Ta vekk landscape i special_gridpage_reportfile
    //Ta vekk blafring når dbscan har bare rapport
    //Scan må få reportnumber så kan vise bare rapport når skanner inn i db med eventid 3 for bare rapport.
    //Kryss felt må fungere å tabe over uten å stoppe opp. Test i arbeidssseddel: Kryss for 0 - fakturering som må fungere med default verdi = 0

    //I "Ny rad": Sette inn i felt (f.eks gridpage_keyno) det samme som blir filtrert på sida for "Ny rad"
    //Lag rowlink_parm1 og rowlink_parm2 så får full kontroll med knappene.
    //Vis søkekolonnes navn dersom bare en kolonne i stedet for 'Søk' foran søkefeltet
    //Test ut telefonkamera qrkode som url for denne løsninga
    //Update trigger lager fil med script for alle menyradene uten at overskrives når oppgraderer
    //Slå på summering på felt på sida
    //Lag eventprosedyre special_dev_rowevent som returnerer nye feltverdiene for oppgitt tabell og felt som slås på med felt "event" i special_gridcolumn (lagra før kallet så finner i basen alle data)
    //Knapper med feltvalg i messageboxer som dukker opp med både verdier og valg mellom to alternativ. Altså to nivå med to valg så i alt 4 valg.
    //Klikk på feltet «søk» så messagebox med alle kolonnene man kan velge.Skifter da fra «søk»  til nVnet på kolonnen og søker i smdeb kononnen.Kan velge tilbake til søk etterpå. Når «søk» så søker på kolonnene som er avkrysset i Kolonner i feltet searchcolumn. Om ingen avkrysset så søker i alle. Eget valg for å beholde tidligere søkekriterier.
    //Kunne oversette felt når er krysset i Kolonner
    
    //Webpage = pg i stedet for fossproduction, 
    //special_pg_ i stedet for special_gridpage_ både for prosedyrer/funksjoner/tabeller/mpds_dev-prosedyrer
    //Kalle spesialoppdatering til kunde automatisk ved oppgradering
    //Prosessmeny med undermenyer for prosesser. Prosess: Hele prosessen fra ordre til levering inkludert standardvinduene.
    //Ctrl f8 ikke søkelækolonne/scannekolonne når ikke er det
    //Bilder i grid der kolonna må heite "item_thumb", og innneholder url til bildet.

    //TIL SKARP

    //"List"-grid med linker som åpner sider med felt for en rad + eventuelt en grid under. Special_gridpagecolumn.title gir gruppering av feltene. Viser også eventuelt bilde.
    //Eksempel: Trykker på "Ordenr": Åpner side med ordehodefeltene for valgt ordre + grid med ordrelinjene til ordren.Trykker på "Kunde": Åpner side med kundefeltene for valgt kunde
    //Når det blir bare en rad på "scan søk", "db søk" eller "weblink" så vis detail-side automatisk.
    //Detail-side kan ha flere kolonner som ikke grid har fordi kolonnene ikke er krysset av for grid i "Kolonner".
    //Har overskrift-felt for grupper av kolonner. Del sida opp i passende antall aviskolonner.
    //Grid kan være readonly liste med weblinks for "key fields" som primary og foreign  keys med knapp "Editer felt" så blir vanlig grid igjen.
    //Grid kan ha "Vis liste"-knapp så blir readonly liste igjen.
    //«Editer felt» og «Vis liste» knappppene plasseres helt vil venstre før "ny rad" - knappen.
    //Felt "Vis liste" i "Sider" som setter i default readonly mode.
    //Kan fjerne knappene «Vis liste» og "Editer felt" når slår av i felt i "Sider"
    //Bare grid som har alle kolonnene blir ikke detail ved ny rad fordi ellers trengs detail for å få plass til alle kolonnene. Kan ha kryss på side som gir detail likevel fordi dette fyller ut små skjermer som ipad.
    //For å få weblinks på en side man er på så må man først trykke på "Vis liste" - knappen
    //Transaksjonsvindu har detail og edit grid i samme sida. Feks ordre.
    //Rapportlinkene er special_gridpage_reportlink. Ikke parameterboks på rapporter, alt er url - parameter Rapporten åpner messagebox med url og navn og direkteutskriftlink til rapporter, 
    //Rapportikon kan slås på eller av på sida. Om er på så viser det om der er rapporter. Klikk på søketittel: Kan velge rapportparameter. Special_gridpage_report har reportname og url.
    //Prosessknapp også slik som rapportknapp, liste med linker til sider før og etter sida i prosessen. Viser ikke link på egen side, og de sidene man ikke har tilgang til. Viktig at alle ser hele prosessen selv om de ikke har tilgang for forståelse av erp-systemet.
    //Setupknapp også slik som rapportknapp. Viser alle sider som setter opp data for sida. Viser bare link om brukeren har tilgang, men viktig at man ser alle sidene osm man registrerer data for forståelse for erp-suystemet

    //Serverside filtrering på grid

    //Mobilt grensesnitt (standard Touchtimevinduer) når horisontal oppløsning er som for telefoner: List-side og edit-side, der list-sida må bli samme som grid-sida bare for telefoner (knapp på grid-sida til list sida til å begynne med)

    //Lag alle vinduen for prosessene bestilling - ordremottak, ordre - leveranse og fakturering. Bruk dynamicsboka og youtube-videoene til å få ideer om prosesser og sideløsninger. Lag rapporter samtidig med sidene: Lag statistikker og vinduer som i worksenter i dynamics for hver meny

    //Gjør forbedringer i systemet ut fra erfaringene med å lage sider.

    //TIL SKARP


    //---------------------------------------------------------------------------------------------------------------------------------------------
    // Sette opp griden (nye felt hentes fra ttGrid.readme.txt)
    //---------------------------------------------------------------------------------------------------------------------------------------------

import { Component, Inject, OnDestroy, OnInit, Optional, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridRow } from '@app/core/components/grid/grid.types';
import { InputComponent } from '@app/core/components/input/input.component';
import { ModalService } from '@app/core/services/modal.service';
import { RememberService } from '@app/core/services/remember.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { FossProductionGet, ProductionButton, ProductionCellParams, ProductionGridParams, ProductionInfoParams, ProductionPageParams, FossProductionService } from '@app/services/foss-production.service';

@Component({
    selector: 'tt-foss-production',
    templateUrl: './foss-production.component.html',
    styleUrls: ['./foss-production.component.css'],
    standalone: false,
})
export class FossProductionComponent implements OnInit, OnDestroy {
    public page?: FossProductionGet;
    public grid?: Grid<GridRow>;
    public scanValue = '';
    public showGrid = true;
    public showReport = false;
    public showSearchField = false;
    public showScanField = false;
    public valid = false;
    public height = 0;
    public gridWidth = 100;
    public previewLink: SafeResourceUrl;
    public buttons: ProductionButton[] = [];
    public busyButton?: string;
    public scanning = false;
    @ViewChild('scanInput') private scanInput?: InputComponent<string>;

    private params!: ProductionPageParams;
    private originalParams!: ProductionPageParams;
    private visualMode: 'grid' | 'grid&report' | 'report' = 'grid';
    private searchValue = '';
    private databaseSearchText = '';
    private readonly searchColumn = '';
    private primaryKey1?: string;
    private primaryKey2?: string;
    private checkboxColumn?: string;
    private lastPrimaryValue1: unknown;
    private lastPrimaryValue2: unknown;
    private reportZoom = 100;
    private previewVersion = 0;
    private destroyed = false;
    private polling = false;
    private readonly pendingCellWrites = new WeakMap<GridRow, Map<string, PendingProductionSave>>();
    private scanTimer?: ReturnType<typeof setTimeout>;
    private pollTimer?: ReturnType<typeof setInterval>;
    private readonly keyboardHandler = (event: KeyboardEvent) => { void this.onKeyDown(event).catch(error => console.error('Production page shortcut failed.', error)); };

    constructor(
        private readonly production: FossProductionService,
        private readonly modal: ModalService,
        private readonly remember: RememberService,
        private readonly sanitizer: DomSanitizer,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
        this.previewLink = this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');
    }

    public async ngOnInit(): Promise<void> {
        const route = this.navigator?.params ?? {};
        this.originalParams = {
            gridpage_keyno: String(route['gridpage_keyno'] ?? ''), p2_datatask_keyno: String(route['p2_datatask_keyno'] ?? ''),
            eventid: String(route['eventid'] ?? ''), reportnumber: String(route['reportnumber'] ?? ''),
            proc_parm1: String(route['proc_parm1'] ?? ''), proc_parm2: String(route['proc_parm2'] ?? ''), proc_parm3: String(route['proc_parm3'] ?? ''),
        };
        this.params = { ...this.originalParams, p2_datatask_keyno: this.originalParams.p2_datatask_keyno || 2244, eventid: this.originalParams.eventid || '0' };
        this.showGrid = this.params.gridpage_keyno !== '0';
        this.showReport = Number(this.params.reportnumber) > 0;
        this.visualMode = !this.showGrid ? 'report' : this.showReport ? 'grid&report' : 'grid';
        this.valid = this.visualMode === 'report' ? ['0', '1', '2', '3', '7', '8', '20'].includes(this.params.eventid) : Number(this.params.eventid) >= 0 && Number(this.params.eventid) <= 20;
        if (!this.valid) return;
        this.showSearchField = ['1', '7', '11', '17'].includes(this.params.eventid);
        this.showScanField = ['2', '3', '4', '12', '13', '14'].includes(this.params.eventid);
        this.height = window.innerHeight - 54 - (this.showSearchField ? 65 : this.showScanField ? 55 : 0);
        const reportHeight = this.showGrid ? 1141 : 808;
        this.reportZoom = this.height / reportHeight * 100;
        this.gridWidth = (window.innerWidth - reportHeight * 0.71 * this.reportZoom / 100) / window.innerWidth * 100;
        const page = await this.production.initialize(this.params);
        if (this.destroyed) return;
        this.page = page;
        this.primaryKey1 = page.primaryKeys[0]?.columnname;
        this.primaryKey2 = page.primaryKeys[1]?.columnname;
        if (this.showGrid) this.initializeGrid();
        if (this.visualMode === 'report' && this.params.eventid !== '20' && Number(page.report?.original_reportpage) > 0) await this.printPreview();
        if (!this.destroyed) {
            window.addEventListener('keydown', this.keyboardHandler, true);
            if (['5', '6', '7', '8', '9', '15', '16', '17', '18', '19', '20'].includes(this.params.eventid)) {
                this.pollTimer = setInterval(() => { void this.poll().catch(error => console.error('Production page refresh failed.', error)); }, 2000);
            }
        }
    }

    private initializeGrid(): void {
        const interactive = ['0', '1', '5', '6', '7', '10', '11', '15', '16', '17', '20'].includes(this.params.eventid);
        this.buttons = interactive ? this.page!.buttons : [];
        this.grid = new Grid().setRememberId('w_fossproduction/' + this.params.gridpage_keyno + '/' + this.params.p2_datatask_keyno + '.remember_id')
            .setLoadDataFunction({ method: Number(this.params.p2_datatask_keyno), parameters: () => this.gridParams() })
            .setToolbar({ pdfExport: false, excelExport: false, filter: false, columnVisibility: false, headers: false, edit: false, lock: false,
                add: false, delete: false, save: false, wrapping: false, layouts: false })
            .setConfig({ editColumns: interactive ? [...this.page!.lookups, ...this.page!.editable] : [],
                fixedHeader: true, keepSortOnAdd: false, keepSortOnCheckbox: false, keepSortOnIsSelected: false, rowClick: false, shortcuts: false })
            .setSpecialFunc({ newTab: true, buttons: [] })
            .setCSSOptions({ altColor: true, textWrapping: true });
        this.grid.kendo = { height: this.height, aggregate: false, pager: false, selectable: this.needsRowSelection() ? 'multiple' : false, filterable: false };
        this.grid.optionfunc = (event: { data: ProductionGridEvent }) => { void this.onGridEvent(event.data).catch(error => console.error('Production page cell action failed.', error)); };
    }

    private needsRowSelection(): boolean {
        return this.buttons.some(button => button.name === 'customDelete' || !!button.rowlink) ||
            this.visualMode === 'grid&report' || (Number(this.params.eventid) >= 10 && Number(this.params.eventid) <= 19 && this.visualMode === 'grid');
    }

    private infoParams(): ProductionInfoParams {
        const { gridpage_keyno, p2_datatask_keyno, proc_parm1, proc_parm2, proc_parm3 } = this.params;
        return { gridpage_keyno, p2_datatask_keyno, proc_parm1, proc_parm2, proc_parm3 };
    }

    private gridParams(): ProductionGridParams {
        const { gridpage_keyno, proc_parm1, proc_parm2, proc_parm3, eventid } = this.params;
        return { gridpage_keyno, proc_parm1, proc_parm2, proc_parm3, eventid, search_column_name1: this.searchColumn, search_column_value1: this.searchValue };
    }

    public async onGridReady(ready: boolean): Promise<void> {
        if (!ready || this.destroyed || !this.grid?.gridfunc) return;
        const first = this.grid.gridfunc.getRows(false, true, true)[0];
        if (this.visualMode === 'grid&report' && Number(this.page?.report?.original_reportpage) > 0) {
            if (first && this.hasPrimaryValue(first[this.primaryKey1!])) this.grid.gridfunc.selectRow(0);
            await this.printPreviewFromRow(first?.[this.primaryKey1!] ?? '', first?.[this.primaryKey2!] ?? '');
        } else if (this.visualMode === 'grid' && Number(this.params.eventid) >= 10 && Number(this.params.eventid) <= 19) {
            await this.broadcast(first?.[this.primaryKey1!] ?? '', first?.[this.primaryKey2!] ?? '');
        }
    }

    public async loadGridData(): Promise<void> {
        if (this.destroyed) return;
        if (this.showGrid) await this.grid?.gridfunc?.read();
        else await this.printPreview();
    }

    public async onSearchChanged(value: string): Promise<void> {
        this.scanValue = value;
        this.searchValue = value;
        await this.loadGridData();
    }

    public onScanChanged(value: string): void {
        this.scanValue = value;
        if (this.scanTimer !== undefined) clearTimeout(this.scanTimer);
        if (!value) return;
        this.scanTimer = setTimeout(() => { void this.onScan(value).catch(error => console.error('Production page scan failed.', error)); }, 500);
    }

    public async onScan(value: string): Promise<void> {
        if (!value || this.destroyed) return;
        this.scanValue = value;
        this.scanning = true;
        try {
            const searchOnly = ['2', '12'].includes(this.params.eventid);
            if (searchOnly) this.searchValue = value;
            const request = this.production.scan({ ...this.infoParams(), eventid: this.params.eventid, p2_webpagelink_keyno: this.page?.menu?.p2_webpagelink_keyno, scantext: searchOnly ? '' : value });
            if (searchOnly) await Promise.all([request, this.loadGridData()]);
            else await request;
            if (this.destroyed) return;
            this.scanValue = '';
            if (!searchOnly) {
                if (['3', '13'].includes(this.params.eventid)) this.searchValue = value;
                await this.loadGridData();
            }
        } finally { this.scanning = false; }
    }

    public async poll(): Promise<void> {
        if (this.destroyed || this.polling) return;
        this.polling = true;
        try {
            if (this.params.eventid === '20') {
                const receivedPage = await this.remember.getLastStatus('w_fossproduction.page');
                const first = await this.remember.getLastStatus('w_fossproduction.pvalue1');
                const second = await this.remember.getLastStatus('w_fossproduction.pvalue2');
                if (!this.destroyed && Number(receivedPage[0]?.variablevalue) === this.page?.report?.original_reportpage) await this.printPreviewFromRow(first[0]?.variablevalue, second[0]?.variablevalue);
            } else {
                const response = await this.production.databaseSearch({ ...this.params, p2_webpagelink_keyno: this.page?.menu?.p2_webpagelink_keyno });
                if (this.destroyed || response.dbsearchtext === this.databaseSearchText) return;
                this.databaseSearchText = response.dbsearchtext;
                if (['5', '8', '15', '18'].includes(this.params.eventid)) this.searchValue = this.databaseSearchText;
                await this.loadGridData();
            }
        } finally { this.polling = false; }
    }

    private hasPrimaryValue(value: unknown): boolean { return Number(value) > 0 || (typeof value === 'string' && value > ''); }

    private cellParams(row: GridRow, column_name: string, column_value: unknown, update: 0 | 1 = 1): ProductionCellParams {
        return { gridpage_keyno: this.params.gridpage_keyno, update, column_name, column_value, primarykey_name1: this.primaryKey1,
            primarykey_value1: row[this.primaryKey1!], primarykey_name2: this.primaryKey2, primarykey_value2: row[this.primaryKey2!] };
    }

    private async writeCell(row: GridRow, column: string, value: unknown): Promise<unknown[]> {
        const writes = this.pendingCellWrites.get(row) ?? new Map<string, PendingProductionSave>();
        this.pendingCellWrites.set(row, writes);
        const previous = writes.get(column);
        if (previous && previous.value === value) return previous.request;
        const params = this.cellParams(row, column, value);
        const request = (previous ? previous.request.catch(() => undefined) : Promise.resolve())
            .then(() => this.production.saveCell(params));
        const pending = { value, request };
        writes.set(column, pending);
        try { return await request; }
        finally { if (writes.get(column) === pending) writes.delete(column); }
    }

    public async onGridEvent(event: ProductionGridEvent): Promise<void> {
        if (!this.page || !this.grid?.gridfunc || this.destroyed) return;
        if (event.func === 'CellClickHandler') {
            this.checkboxColumn = undefined;
            const row = this.grid.gridfunc.getSelectedRows()[0];
            if (!row) return;
            const first = row[this.primaryKey1!], second = row[this.primaryKey2!] ?? '';
            if (this.visualMode === 'grid' && Number(this.params.eventid) >= 10 && Number(this.params.eventid) <= 19) await this.broadcast(first, second);
            if ((!this.page.report?.landscape && this.visualMode === 'grid&report') || (this.page.report?.landscape && this.visualMode === 'report')) {
                if (this.hasPrimaryValue(first)) await this.printPreviewFromRow(first, second);
            }
        } else if (event.func === 'OnCellClose') {
            this.checkboxColumn = undefined;
            const row = event.rdata ?? this.grid.gridfunc.getRows(false, true, true)[event.ridx ?? -1];
            const dirty = this.grid.gridfunc.getDirtyRows()[0];
            if (!row || !event.cval || !this.hasPrimaryValue(row[this.primaryKey1!]) || !dirty || !(dirty['dirty'] || dirty['_dirty'])) return;
            const column = event.cval;
            const isName = column.startsWith('dropdown');
            if (!isName) {
                await this.writeCell(row, column, event.change);
                dirty['dirty'] = false; dirty['_dirty'] = false;
            }
            const index = this.page.dropdowns.findIndex(item => item.key === column);
            const paired = isName ? this.page.dropdowns[parseInt(column.slice(8), 10) - 1]?.key : index >= 0 ? 'dropdown' + (index + 1) : undefined;
            if (!paired) return;
            let value = event.change;
            if (isName) {
                const text = String(value ?? '');
                let id = String(parseInt(text, 10));
                if (id === 'NaN') {
                    const space = text.indexOf(' ');
                    id = space !== -1 ? text.substring(space + 1) : 'NaN';
                }
                value = text.replace(id, '').trim();
                row[column] = value;
            }
            const response = await this.production.lookup({ gridpage_keyno: this.params.gridpage_keyno, column_name: column, column_value: value });
            if (this.destroyed) return;
            row[paired] = response[0]?.key;
            const focused = this.grid.gridfunc.getGridApi().getFocusedCell();
            this.grid.gridfunc.refresh();
            if (focused) this.grid.gridfunc.startCellEditing({ rowIndex: event.ridx ?? this.grid.gridfunc.getRowIndex(row), columnKey: focused.column.getColId() });
            if (isName) {
                await this.writeCell(row, paired, row[paired]);
                dirty['dirty'] = false; dirty['_dirty'] = false;
            }
        } else if (event.func === 'CheckboxBoxClick' && event.key && event.dataItem) {
            this.checkboxColumn = event.key;
            if (!this.hasPrimaryValue(event.dataItem[this.primaryKey1!])) return;
            await this.writeCell(event.dataItem, event.key, event.dataItem[event.key]);
            if (this.page.refreshColumns.some(column => column.columnname === event.key)) await this.loadGridData();
        }
    }

    public async runButton(button: ProductionButton): Promise<void> {
        if (this.busyButton || this.destroyed) return;
        this.busyButton = button.name;
        try {
            // The legacy precedence is procedure, row link, static link, then add/delete.
            if (button.callproc === 1 || button.callproc === true) {
                for (const row of this.grid?.gridfunc?.getSelectedRows() ?? []) {
                    if (this.hasPrimaryValue(row[this.primaryKey1!])) await this.production.button({
                        gridpage_keyno: this.params.gridpage_keyno, buttonname: button.name, p2_webpagelink_keyno: this.page?.menu?.p2_webpagelink_keyno,
                        primarykey_value1: row[this.primaryKey1!], primarykey_value2: row[this.primaryKey2!],
                    });
                }
                this.grid?.gridfunc?.refresh();
            } else if (button.rowlink) this.rowLink(button.rowlink, button.rowlink_parm3 ?? '');
            else if (button.link) {
                const parts = button.link.split('/');
                const link = parts[0] === this.params.gridpage_keyno ?
                    [this.params.gridpage_keyno, this.originalParams.p2_datatask_keyno, this.originalParams.eventid, this.params.reportnumber, parts[4], parts[5], parts[6]].join('/') : button.link;
                this.goTo('/#/fossproduction/' + link);
            } else if (button.name === 'customAddBefore') await this.newRow();
            else if (button.name === 'customDelete') await this.deleteRows();
        } finally { this.busyButton = undefined; }
    }

    public goTo(url: string): void { window.location.href = url; }

    public rowLink(link: string, third: string): void {
        const row = this.grid?.gridfunc?.getSelectedRows()[0];
        if (!row || !this.hasPrimaryValue(row[this.primaryKey1!])) return;
        let target = link + (third ? '/' + third : '');
        if (!target.includes('/')) target += '///';
        const count = target.split('/').length - 1;
        if (count === 3) target += '/' + row[this.primaryKey1!] + '/' + (row[this.primaryKey2!] ?? '') + '/' + third;
        else if (count === 4) target += '/' + row[this.primaryKey1!] + '/' + third;
        else if (count === 5) target += '/' + third;
        else if (count !== 6) return;
        this.goTo('/#/fossproduction/' + target);
    }

    public async newRow(): Promise<void> {
        const defaults = await this.production.newRow(this.params.gridpage_keyno);
        if (this.destroyed) return;
        const row: GridRow = {};
        defaults.forEach(item => row[item.columnname] = item.defaultvalue);
        await this.grid?.gridfunc?.addRowBefore(0, row);
    }

    public async deleteRows(): Promise<void> {
        const rows = this.grid?.gridfunc?.getSelectedRows() ?? [];
        if (!rows.length) { await this.info('Advarsel', 'Velg rader å slette'); return; }
        const confirmed = await this.modal.openConfirmDialog({ title: 'Bekreft', message: rows.length === 1 ? 'Slette valgte linje?' : 'Slette valgte ' + rows.length + ' linjer?', translateTitle: false, translateMessage: false });
        if (!confirmed || this.destroyed) return;
        for (const row of rows) {
            if (!this.hasPrimaryValue(row[this.primaryKey1!])) continue;
            await this.production.saveCell({ ...this.cellParams(row, '', null, 0), column_name: null });
            if (!this.destroyed) await this.grid?.gridfunc?.removeRow(row);
        }
    }

    private async broadcast(first: unknown, second: unknown): Promise<void> {
        if (first === this.lastPrimaryValue1 && second === this.lastPrimaryValue2) return;
        this.lastPrimaryValue1 = first; this.lastPrimaryValue2 = second;
        await Promise.all([
            this.remember.remember('w_fossproduction.page', this.params.gridpage_keyno),
            this.remember.remember('w_fossproduction.pvalue1', first), this.remember.remember('w_fossproduction.pvalue2', second),
        ]);
    }

    private async printPreviewFromRow(first: unknown, second: unknown): Promise<void> {
        if (first === this.lastPrimaryValue1 && second === this.lastPrimaryValue2) return;
        this.lastPrimaryValue1 = first; this.lastPrimaryValue2 = second;
        await this.printPreview(first, second);
    }

    public async printPreview(first?: unknown, second?: unknown): Promise<void> {
        const report = this.page?.report;
        if (!report?.reportdef_keyno || this.destroyed) return;
        const { proc_parm1, proc_parm2, proc_parm3, eventid } = this.params;
        let values: unknown[];
        if (this.visualMode === 'grid&report') values = this.hasPrimaryValue(second) ? [first, second, proc_parm1, proc_parm2, proc_parm3] : [first, proc_parm1, proc_parm2, proc_parm3];
        else if (this.visualMode === 'report') {
            if (eventid === '0') values = [proc_parm1, proc_parm2, proc_parm3];
            else if (['1', '2', '3'].includes(eventid)) values = [this.searchValue, proc_parm1, proc_parm2, proc_parm3];
            else if (eventid === '7') values = [this.databaseSearchText, this.searchValue, proc_parm1, proc_parm2, proc_parm3];
            else if (eventid === '8') values = [this.databaseSearchText, proc_parm1, proc_parm2, proc_parm3];
            else if (eventid === '20') values = [first, second, proc_parm1, proc_parm2, proc_parm3];
            else return;
        } else return;
        // Legacy initialization supplies only argtype1 and argtype2.
        const parameters: Record<string, unknown> = {};
        if (report.argtype1) parameters[report.argtype1] = values[0];
        if (report.argtype2) parameters[report.argtype2] = values[1];
        const version = ++this.previewVersion;
        const url = await this.production.preview({ reportKeyno: report.reportdef_keyno, parameters });
        if (!this.destroyed && version === this.previewVersion) this.previewLink = this.sanitizer.bypassSecurityTrustResourceUrl(url + '#toolbar=0&zoom=' + this.reportZoom);
    }

    private info(title: string, message: string): Promise<void> { return this.modal.show({ type: 'none', title, message }); }

    public async onKeyDown(event: KeyboardEvent): Promise<void> {
        if (!this.page || this.destroyed) return;
        const key = event.key.toLowerCase();
        if (event.key === 'F1') {
            event.preventDefault();
            const details = await this.production.info(this.infoParams());
            await this.info(this.page.menu?.menuname ?? '', (details[4]?.key ?? '') + (details[2]?.key ?? ''));
        }
        if (event.ctrlKey && key === 'i' && this.buttons.some(button => button.name === 'customAddBefore')) {
            event.preventDefault(); await this.runButton(this.buttons.find(button => button.name === 'customAddBefore')!);
        }
        if (event.ctrlKey && key === 'g') event.preventDefault();
        if (event.ctrlKey && event.key === 'F8') {
            event.preventDefault();
            const details = await this.production.info(this.infoParams());
            const sql = await this.production.gridSql(this.gridParams());
            const procedure = details[1]?.key ?? '';
            await this.info(this.page.menu?.menuname ?? '', (details[0]?.key ?? '') + (procedure ? ' i ' : '') + procedure + (details[3]?.key ?? '') + '<BR>' + sql.gridsql);
        }
        if (event.shiftKey && event.key === 'F8') {
            event.preventDefault();
            const details = await this.production.info(this.infoParams());
            const field = this.checkboxColumn ?? this.grid?.gridfunc?.getGridApi().getFocusedCell()?.column.getColId();
            if (field) {
                const fixed = [details[0]?.key, details[1]?.key, this.page.menu?.menuname, details[3]?.key, details[4]?.key];
                const column = details.find(item => item.key.startsWith(field) && !fixed.includes(item.key));
                const procedure = details[1]?.key ?? '';
                await this.info(column?.key.replace(/<BR>/g, ' ') ?? field, column ?
                    (details[0]?.key ?? '') + '.' + column.key + (procedure ? ' i ' : '') + procedure : field + ' i ' + procedure);
            }
        }
        if (event.ctrlKey && event.shiftKey) {
            const page = this.params.gridpage_keyno;
            const targets: Record<string, string> = {
                p: '#/fossproduction/2////' + page + '//', k: '#/fossproduction/3////' + page + '//',
                b: '#/fossproduction/4////' + page + '//', y: '#/fossproduction/5/////' + (this.page.menu?.menuname ?? '') + '/',
                f: '#/fossproduction/8////' + (page === '0' ? this.page.report?.original_reportpage : page) + '//',
                i: '#/fossproduction/12////' + this.params.eventid + '/' + this.visualMode + '/',
            };
            if (targets[key]) { event.preventDefault(); this.goTo(targets[key]); }
        }
    }

    public ngOnDestroy(): void {
        this.destroyed = true;
        this.previewVersion++;
        window.removeEventListener('keydown', this.keyboardHandler, true);
        if (this.pollTimer !== undefined) clearInterval(this.pollTimer);
        if (this.scanTimer !== undefined) clearTimeout(this.scanTimer);
        this.scanInput?.focusSubscription?.unsubscribe();
    }
}

export interface ProductionGridEvent {
    func: string; ridx?: number; cidx?: number; cval?: string; change?: unknown; rdata?: GridRow; key?: string; dataItem?: GridRow;
}

interface PendingProductionSave { value: unknown; request: Promise<unknown[]>; }
